import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  date = new Date();
  copyRightYear = this.date.getFullYear();

  constructor(private router: Router) {}

  ngOnInit() {}
  goHome() {
    this.router.navigate(['/']);
  }
}
